// Hoisted so it isn't redefined per-section. Pure function, no closure deps.
const isMobile = () => window.innerWidth < 768;

document.addEventListener( 'DOMContentLoaded', () => {
	document.querySelectorAll( '.outcome-section' ).forEach( ( section ) => {
		if ( section.classList.contains( 'outcome-section--layout-2' ) ) return;
		const cards = section.querySelectorAll( '.outcome-section__card' );
		if ( ! cards.length ) return;

		let prevActiveIndex = 0;

		function activateCard( index, animate = true ) {
			// Interactive re-click of the already-active card is a no-op — bail
			// before computing a direction that would otherwise default to
			// slide-from-left and re-trigger the keyframe on a card that did
			// not move. The initial sync (`animate === false`) must still run
			// so non-active cards receive their tabindex/role/aria-label.
			if ( animate && index === prevActiveIndex && cards[ index ]?.classList.contains( 'is-active' ) ) {
				return;
			}
			const direction = index > prevActiveIndex ? 'slide-from-right' : 'slide-from-left';
			cards.forEach( ( card, i ) => {
				const isActive = i === index;
				card.classList.toggle( 'is-active', isActive );
				card.classList.remove( 'slide-from-left', 'slide-from-right' );
				if ( isActive ) {
					card.removeAttribute( 'tabindex' );
					card.removeAttribute( 'role' );
					card.removeAttribute( 'aria-label' );
					if ( animate ) card.classList.add( direction );
				} else {
					card.setAttribute( 'tabindex', '0' );
					card.setAttribute( 'role', 'button' );
					const label = card.querySelector( '.outcome-section__card-title' )?.textContent?.trim();
					if ( label ) card.setAttribute( 'aria-label', label );
				}
			} );
			prevActiveIndex = index;
		}

		cards.forEach( ( card, i ) => {
			// Prevent the browser from focusing the element on mousedown, which would
			// trigger a scroll-into-view that shifts the viewport before the click fires.
			card.addEventListener( 'mousedown', ( e ) => {
				if ( isMobile() ) return;
				if ( ! card.classList.contains( 'is-active' ) ) e.preventDefault();
			} );
			card.addEventListener( 'click', () => {
				if ( isMobile() ) return;
				if ( ! card.classList.contains( 'is-active' ) ) {
					const scrollY = window.scrollY;
					activateCard( i );
					// Restore scroll position in case the layout expansion caused any drift.
					requestAnimationFrame( () => window.scrollTo( { top: scrollY, behavior: 'instant' } ) );
				}
			} );
			card.addEventListener( 'keydown', ( e ) => {
				if ( ( e.key === 'Enter' || e.key === ' ' ) && ! card.classList.contains( 'is-active' ) ) {
					e.preventDefault();
					activateCard( i );
				}
			} );
		} );

		// First card active on load — no animation (PHP already sets is-active; this syncs a11y attrs)
		activateCard( 0, false );
	} );
} );
